import React from "react";

import { Icons } from "2g-icons";
import { SlideBar } from "2g-slidebar";

import useNotifikaceIcon from "./useNotifikaceIcon";
import NotifikaceWidget from "./NotifikaceWidget";

export function NotifikaceIcon() {
  const { slidebar, data, unreadCount, reload } = useNotifikaceIcon();
  return (
    <>
      <div className="b2b-Notifikace-icon" onClick={slidebar.onOpen}>
        <Icons.MessageAlert />
        {unreadCount > 0 ? (
          <span className="b2b-Notifikace-iconCount">{unreadCount}</span>
        ) : undefined}
      </div>
      <SlideBar {...slidebar} className="b2b-Notifikace-slideBar">
        <NotifikaceWidget
          onClose={slidebar.onClose}
          notifikace={data}
          onSuccess={reload}
        />
      </SlideBar>
    </>
  );
}

NotifikaceIcon.propTypes = {};

export default React.memo(NotifikaceIcon);
